import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {DeleteClaimDocumentComponent} from "./delete-claim-document.component";

declare module '@spartacus/storefront' {
}

export const deleteClaimModalLayout: LayoutConfig = {
  launch: {
    DELETE_CLAIM_DOCUMENT: {
      inlineRoot: true,
      component: DeleteClaimDocumentComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    }
  },
};
